module.exports = __webpack_public_path__ + "img/IMG-20200919-WA0079.a263c0a0.jpg";